import { TemplateConfig } from '@rxweb/grid';

export const REGISTERED_USER_GRID_TEMPLATE: TemplateConfig = {
    span: {
        class: [function (e) {
            return this[e.name] == true ? "label f-12 text-white activebadge-bg".split(" ") : 'label f-12 text-white inactivebadge-bg'.split(" ");
        }],
        childrens: [{
            text: {
                text: function (e) {
                    return this[e.name] == true ? "Yes" : "No"
                }
            }
        }]
    }
}
